import React from 'react';
import PropTypes from 'prop-types';
import BenefitItem from './BenefitItem';
import BenefitsImage from '@/images/bike-ampersand.png';

const BenefitsSection = ({ title, benefits, src, visualAlignment }) => {

  return (
    <div className={`bg-white text-center lg:text-left px-8 py-14 lg:px-24 xl:px-44 2xl:px-60 lg:py-16 w-full ${src ? '' : 'flex justify-center'}`}>
    <div className={`max-w-7xl mx-auto flex flex-col-reverse ${src ? 'lg:flex-row lg:gap-10' : ''} items-center`}>
      {src && visualAlignment=='left' && (
          <div className="lg:pl-6">
            <img
              src={src || BenefitsImage}
              alt="Benefits Visual"
              className="h-[291px] lg:h-[463px]"
            />
          </div>
      )}
      <div className={`flex-1 space-y-4 md:space-y-0 md:flex md:flex-col text-[#1C2938] ${src ? 'xl:pr-20' : 'mx-auto w-3/5'}`}>
          <h2 className="lg:text-4xl text-2xl font-bold mb-6">
            {title}
          </h2>
          <div className="
            flex flex-1 flex-col justify-center space-y-6 lg:space-y-0
            divide-y divide-gray-300 max-w-[635px]sm:text-nowrap
          ">
            {benefits.map((benefit, index) => (
              <div key={index} className="py-4 sm:px-28 lg:px-0">
                <BenefitItem {...benefit} />
              </div>
            ))}
          </div>
        </div>
        {src && visualAlignment=='right' && (
          <div className="lg:pl-6">
            <img
              src={src}
              alt="Benefits Visual"
              className="h-[291px] lg:h-[463px]"
            />
          </div>
        )}
      </div>
    </div>
  );
};

BenefitsSection.propTypes = {
  title: PropTypes.string,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      icon: PropTypes.string,
    })
  ),
  src: PropTypes.string,
  visualAlignment: PropTypes.string
};

BenefitsSection.defaultProps = {
  visualAlignment: 'right'
}
export default BenefitsSection;
